<template>
    <div>
        <nav class="navbar fixed-top navbar-expand-lg navbar-light bg-light-tr">
            <div class="container" ref="navContainer">
                <a href="#" @click.prevent="goHome()" class="navbar-brand">
                    <img src="../../assets/PimblrLogo.png" alt="Pimblr">
                </a>
                <button class="navbar-toggler" @click="toggleNav()" type="button">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class=" navbar-collapse d-none" id="navbarSupportedContent">
                    <form class="form-inline mr-auto mt-2 mt-lg-0">
                        <search-field/>
                    </form>

                    <ul class="navbar-nav my-2 my-lg-0">
                        <component :is="a.subs?'li':'router-link'"
                          v-for="a in navigation" :key="a.name" :to="{name:a.name}"
                          tag="li"
                          class="nav-item"
                          :class="{dropdown: a.subs, active: hasActiveSubs(a)}"
                          activeClass="active"
                        >
                            <!-- Regular Link -->
                            <a v-if="!a.component && !a.subs" class="nav-link" :title="a.label" :ref="'navtt-'+a.name">
                              <fa-icon :icon="a.icon" :size="iconSize"/>
                            </a>

                            <!-- Dropdown -->
                            <a v-if="!a.component && a.subs"
                               class="nav-link"
                               :title="a.label"
                               :ref="'navtt-'+a.name"
                               href="#"
                               @click.prevent="toggleDropdown(a.name)"
                            >
                              <fa-icon :icon="a.icon" :size="iconSize"/>
                            </a>
                            <div v-if="!a.component && a.subs" class="dropdown-menu dropdown-menu-right" :class="{show: dropdowns[a.name]}">
                              <a v-for="sub in a.subs"
                                 class="dropdown-item"
                                 :class="{active: isActive(sub)}"
                                 href="#"
                                 @click.prevent="subnavClick(sub.name, a.name)">
                                  <span class="icn"><fa-icon :icon="sub.icon"/></span>
                                  {{sub.label}}
                              </a>

                              <div v-if="a.name === 'TopProfile'" class="dropdown-divider"></div>
                              <a v-if="a.name === 'TopProfile'" class="dropdown-item" href="#" @click.prevent="logout">
                                <span class="icn"><fa-icon :icon="['fal', 'power-off']"/></span>
                                Logout
                              </a>
                            </div>

                            <!-- Components -->
                            <component v-if="a.component" :is="a.component" :ref="'navtt-'+a.name">
                              <fa-icon :icon="a.icon" :size="iconSize"/>
                            </component>
                        </component>

                        <router-link v-if="!isLoggedIn" to="/login" tag="li" class="nav-item" activeClass="active"><a class="nav-link">Login</a></router-link>

                    </ul>

                </div>
            </div>
        </nav>



    </div>
</template>

<script>

    import SearchField from '../ui/SearchField.vue'
    import nav from '../../store/Navigation'
    import Tooltip from 'tooltip.js'

    export default {
        name: 'MainNavigation',
        data(){
            return {
                navigation: nav.main,
                iconSize: '2x',
                dropdowns: {},
                tooltips: {}
            }
        },
        computed: {
            isLoggedIn(){
                return this.$store.state.user.isLoggedIn;
            },
            followingBlogs() {
              return this.$store.state.user.follows.length
            }
        },
        mounted () {
          for(let ref in this.$refs) {
            if (ref.substr(0, 6) === 'navtt-') {
              const name = ref.substr(6);
              const el = (this.$refs[ref][0]) ? this.$refs[ref][0].$el || this.$refs[ref][0] : this.$refs[ref];
              this.tooltips[name] = new Tooltip(el, {
                title: el.title,
                container: this.$refs.navContainer
              });
            }
          };
        },
        methods: {
            toggleNav(){
                this.$bus.$emit('sidebar.toggle');
            },
            logout(){
                this.$store.commit('user/unsetToken');
                this.$router.push({name: 'Login'})
            },
            goHome(){
                if(this.isLoggedIn){
                    this.$router.push({name:'Dashboard'})
                } else {
                    this.$router.push({name:'Startpage'})
                }
            },
            subnavClick(routeName, dropDownName) {
              this.$router.push({name: routeName});
              this.toggleDropdown(dropDownName);
            },
            toggleDropdown(dropDownName) {
              if (this.dropdowns[dropDownName] === undefined) this.dropdowns[dropDownName] = false;
              this.$set(this.dropdowns, dropDownName,  !this.dropdowns[dropDownName]);
              this.dropdowns = Object.assign({}, this.dropdowns);
              if(this.tooltips[dropDownName]) this.tooltips[dropDownName].hide();
            },
            isActive(sub) {
              return this.$route.name === sub.name;
            },
            hasActiveSubs(parent) {
              let hasActive = false;
              if(parent.subs) {
                parent.subs.forEach((sub) => {
                  if (this.$route.name === sub.name) hasActive = true;
                })
              }
              return hasActive;
            }
        },
        components: {
            SearchField
        }
    }
</script>

<style lang="sass" scoped>

    @import '../../assets/sass/vars.scss'

    .bg-light-tr
        background-color: rgba(255,255,255,.9)

    .navbar-brand img
        height: 26px

    .nav-item
      margin-left: .4em
      font-size: .95em

    .dropdown-item.active
      background-color: transparent
      color: $colorPrimary

      .icn
        color: $colorPrimary

    .icn
      display: inline-block
      width: 30px
      color: #666
      font-size: 1.2em

    li
      width: 50px
      height: 50px
      text-align: center


    li.active a.nav-link
      background-color: #f2f2f2
      color: #FFF
      border-radius: 8px
      fill: #FFF

</style>



// WEBPACK FOOTER //
// src/components/layout/MainNavigation.vue